<template>
    <el-dialog :visible="visible" @close="handleClose" :class="['calendar-item-dialog', 'ah-detail-dialog']" :modal-append-to-body="false">
        <template slot="title">
            <center>{{ date }} ({{ getWeekDay(date) }})<span style="margin-left: 12px">預計收支</span></center>
        </template>
        <div class="detail-row">
            <div class="detail-block">
                <center>
                    <el-radio-group v-model="tab" style="margin-bottom: 20px">
                        <el-radio-button label="income">收入 ({{ incomeCount }})</el-radio-button>
                        <el-radio-button label="payout">支出 ({{ payoutCount }})</el-radio-button>
                    </el-radio-group>
                </center>
                <el-table :data="displayPreItems" style="width: 100%; margin-bottom: 12px" :summary-method="getTableSummaries" show-summary empty-text="無資料">
                    <el-table-column type="index" label="" width="50"></el-table-column>
                    <el-table-column prop="pdat" width="110" v-if="false">
                        <template slot="header"> 預計付款日期 </template>
                        <template slot-scope="scope">
                            <span>{{ scope.row.pdat | dateFormater("YYYY-MM-dd") }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="groupName" label="類型" width="95">
                        <template slot-scope="scope">
                            <span
                                :class="{
                                    'type-tag': true,
                                    primary: scope.row.groupName == 'INVOICE' || scope.row.groupName == 'PAYOUT'
                                }"
                                >{{ getGroupNameText(scope.row.groupName) }}</span
                            >
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="狀態" width="105">
                        <template slot-scope="scope">
                            <payment-status-label v-if="scope.row.groupName == 'PAYOUT'" :statusNum="scope.row.status" />
                            <invoice-status-label v-if="scope.row.groupName == 'INVOICE'" :statusNum="scope.row.status" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="number" label="單號" width="130">
                        <template slot-scope="scope">
                            <div v-if="scope.row.groupName != 'SALARY'" @click="handleItemClick(scope.row.groupName, scope.row.sno)" @keydown="() => {}" style="color: #3d53c6; cursor: pointer">
                                {{ scope.row.number }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="iteM_NAM" label="摘要">
                        <template slot-scope="scope">
                            <div style="font-weight: 500">
                                {{ scope.row.iteM_NAM }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="amt" label="金額" width="130" align="right">
                        <template slot-scope="scope">
                            <ahTip style="margin-right: 8px" v-if="scope.row.cny !== 'TWD'">
                                <div>
                                    約當台幣：
                                    <Money :v="scope.row.rat ? scope.row.amt * scope.row.rat : scope.row.amt * getCnyRat(scope.row.cny)" round />
                                </div>
                                <div
                                    style="
                                        font-size: 9pt;
                                        opacity: 0.7;
                                        margin-top: 5px;
                                    "
                                >
                                    (以匯率
                                    {{ Math.round(scope.row.rat * 100) / 100 || getCnyRat(scope.row.cny) }}
                                    計算)
                                </div>
                            </ahTip>
                            <Money :v="scope.row.amt" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="cny" label="幣別" width="75">
                        <template slot-scope="scope">
                            {{ cnyName[scope.row.cny] }}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <InvoiceDetailDialog :sno="invoiceDetailDialogSno" :visible="invoiceDetailDialogVisible" @close="handleInvoiceDetailDialogClose" />
        <PaymentDetailDialog :sno="paymentDetailDialogSno" :visible="paymentDetailDialogVisible" @close="handlePaymentDetailDialogClose" />
        <VariableStatementDetailDialog :sno="variableDetailDialogSno" :visible="variableDetailDialogVisible" @edit="onVariableDetailDialogEdit" @close="handleVariableDetailDialogClose" />
        <VariableStatementEditDialog :sno="variableEditDialogSno" :visible="variableEditDialogVisible" @close="onEditDialogVisibleChange" />
    </el-dialog>
</template>
<script>
import InvoiceDetailDialog from '@/components/dashboard/Invoice/InvoiceDetailDialog.vue';
import PaymentDetailDialog from '@/components/dashboard/Payment/PaymentDetailDialog.vue';
import InvoiceStatusLabel from '@/components/dashboard/Invoice/InvoiceStatusLabel.vue';
import PaymentStatusLabel from '@/components/dashboard/Payment/PaymentStatusLabel.vue';
import VariableStatementDetailDialog from '@/components/dashboard/Finance/VariableStatement/DetailDialog.vue';
import VariableStatementEditDialog from '@/components/dashboard/Finance/VariableStatement/EditDialog.vue';

import ahTip from '@/components/ui/ahTip.vue';
import { cnyName } from '@/assets/commonData/options';

export default {
    components: {
        ahTip,
        InvoiceDetailDialog,
        PaymentDetailDialog,
        InvoiceStatusLabel,
        PaymentStatusLabel,
        VariableStatementDetailDialog,
        VariableStatementEditDialog,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        date: {
            type: String,
            default: '', // 2020-12-25
        },
        type: {
            type: String,
            default: 'income', // income | payout
        },
        items: {
            type: Object,
            default() {
                return {
                    invoice: [],
                    refund: [],
                    payout: [],
                    vIn: [],
                    vOut: [],
                };
            },
        },
    },
    watch: {
        type(newVal) {
            if (newVal) {
                this.tab = newVal;
            }
        },
    },
    data() {
        return {
            cnyName,
            tab: 'income',
            paymentDetailDialogSno: null,
            paymentDetailDialogVisible: false,
            invoiceDetailDialogSno: null,
            invoiceDetailDialogVisible: false,
            variableDetailDialogSno: null,
            variableDetailDialogVisible: false,
            variableEditDialogSno: null,
            variableEditDialogVisible: false,
        };
    },
    computed: {
        displayPreItems() {
            if (this.tab === 'income') {
                return this.items.invoice.concat(this.items.vIn);
            }
            if (this.tab === 'payout') {
                return this.items.payout.concat(this.items.refund, this.items.salary, this.items.vOut);
            }
            return [];
        },
        incomeCount() {
            return this.items.invoice.length + this.items.vIn.length;
        },
        payoutCount() {
            return this.items.payout.length + this.items.refund.length + this.items.vOut.length + this.items.salary.length;
        },
    },

    methods: {
        getCnyRat(cny) {
            const cnyOption = this.$store.getters['cny/cnyOptions'].find((x) => x.cny === cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },
        getWeekDay(dateString) {
            const date = new Date(dateString);
            const weekDays = ['日', '一', '二', '三', '四', '五', '六'];
            return weekDays[date.getDay()];
        },
        handleClose() {
            this.$emit('close');
        },
        handlePaymentDetailDialogClose() {
            this.paymentDetailDialogVisible = false;
            this.paymentDetailDialogSno = null;
            this.$emit('refresh');
        },
        handleInvoiceDetailDialogClose() {
            this.invoiceDetailDialogVisible = false;
            this.invoiceDetailDialogSno = null;
            this.$emit('refresh');
        },
        onVariableDetailDialogEdit({ sno }) {
            this.variableEditDialogVisible = true;
            this.variableEditDialogSno = sno;
        },
        handleVariableDetailDialogClose() {
            this.variableDetailDialogVisible = false;
            this.variableDetailDialogSno = null;
            this.$emit('refresh');
        },
        onEditDialogVisibleChange() {
            this.variableEditDialogVisible = false;
            this.variableEditDialogSno = null;
        },
        handleItemClick(type, sno) {
            if (type === 'INVOICE') {
                this.invoiceDetailDialogVisible = true;
                this.invoiceDetailDialogSno = sno;
            } else if (type === 'PAYOUT') {
                this.paymentDetailDialogVisible = true;
                this.paymentDetailDialogSno = sno;
            } else if (type === 'VIN' || type === 'VOUT') {
                this.variableDetailDialogVisible = true;
                this.variableDetailDialogSno = sno;
            }
        },
        getGroupNameText(code) {
            if (code === 'PAYOUT') return '請款單';
            if (code === 'INVOICE') return '發票';
            if (code === 'VIN') return '財務收入';
            if (code === 'VOUT') return '財務支出';
            if (code === 'SALARY') return '實付薪資';
            return '';
        },
        getTableSummaries(param) {
            const { columns, data } = param;
            const sums = [];

            columns.forEach((column, index) => {
                if (column.property === 'amt') {
                    sums[index] = 0;
                    for (let i = 0; i < data.length; i += 1) {
                        if (data[i].cny === 'TWD') {
                            sums[index] += data[i].amt;
                        } else {
                            sums[index] += Math.round(data[i].amt * data[i].rat);
                        }
                        console.log(data[i].amt);
                    }

                    sums[index] = this.formatedAmt(sums[index]);
                    sums[index] += '';
                } else if (column.property === 'cny') {
                    sums[index] = '新台幣';
                } else if (column.property === 'groupName') {
                    sums[index] = '合計';
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        },

        formatedAmt(amt) {
            const value = Number(amt).toLocaleString('en');
            if (this.zero && value === 0) return this.zero;

            if (value === 'NaN') return '';

            if (this.showPositivePlus === true) {
                if (this.v > 0) return `+${value}`;
            }

            return value;
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.calendar-item-dialog {
    &.ah-detail-dialog .el-dialog {
        width: auto;
        max-width: 1200px;
    }

    .type-tag {
        font-size: 9.5pt;
        font-weight: 600;
        color: #444;
        padding: 4px 7px;
        border-radius: 4px;
        margin-right: 7px;
        background-color: #ddd;

        &.primary {
            color: $main-color;
            background-color: #3d53c622;
        }
    }

    .el-table th,
    .el-table td {
    }

    .el-table__header th {
        background-color: #f9f9f9;
        font-size: 10pt;
        padding: 8px 0;
    }

    .el-table__body td {
        color: #000;
    }

    .el-table__footer td {
        background-color: #f9f9f9;
        font-weight: bold;
    }
}
</style>
